import request from '@/service/lib/request'

/**
 * 性诱诱捕器 - 图表数据
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getStatistic(companyId) {
  return request({
    url: '/api/v1/insect-traps/statistics',
    method: 'get',
    params: { companyId }
  })
}

/**
 * 性诱诱捕器 - 汇总当前数据
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getPreview(params) {
  return request({
    url: '/api/v1/insect-traps/preview',
    method: 'get',
    params
  })
}
